import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const consolidatedPositionStrategyEnum = {
  NotInformed: 0,
  VariableIncome: 1,
  InvestmentAbroad: 2,
  Multimarket: 3,
  FixedIncome: 4,
  Currency: 5,
  Prefixed: 6,
  Postfixed: 7,
  Inflation: 8,
  Crypture: 9,
  Clubs: 10,
  PrivateFund: 11,
  PensionFund: 12,
};

export type ConsolidatedPositionStrategyEnum =
  (typeof consolidatedPositionStrategyEnum)[keyof typeof consolidatedPositionStrategyEnum];

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 3 },
  { title: 'Valor  bruto', flex: 1.2 },
  { title: 'Valor investido', flex: 1.2 },
  { title: 'Quantidade' },
  { title: 'Rentabilidade' },
];
